import {
  Box,
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Link,
  Text,
} from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { emailValidate, passwordValidate } from "../utils";
import { auth, db } from "../../Firebase";
import { FcGoogle } from "react-icons/fc";
import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { AuthContext } from "../Context/AuthContext/AuthContext";
import Navbar from "../Components/Navbar";
import { doc, setDoc } from "firebase/firestore";
const Login = () => {
  // const fire = project - 654148757815;
  const [isLoading, setLoading] = useState(false);
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const provider = new GoogleAuthProvider();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  async function handleLogin(data) {
    setLoading(true);
    try {
      let res = await signInWithEmailAndPassword(
        auth,
        data.email,
        data.password
      );
      console.log(res);
      loginUser(res.user);
      setLoading(false);
      toast({
        title: "login successful",
        description: "have a great day.",
        status: "success",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      reset();
      navigate("/");
    } catch (error) {
      toast({
        title: "login failed",
        description: error.message,
        status: "error",
        position: "top",
        duration: 4000,
        isClosable: true,
      });
      setLoading(false);
      console.log(error);
    }
  }
  const handleGoogle = async () => {
    try {
      let res = await signInWithPopup(auth, provider);
      console.log("res", res);
      loginUser(res.user);
      await setDoc(doc(db, "users", res.user.uid), {
        id: res.user.uid,
        email: res.user.email,
        password: "83645322",
        avatar: "",
        date: Date.now(),
      });
      await setDoc(doc(db, "cart", res.user.uid), {
        id: res.user.uid,
        cart: [],
      });
      await setDoc(doc(db, "completed", res.user.uid), {
        completed: [],
      });
      toast({
        title: "Sign in successful",
        description: "have a great day.",
        status: "success",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      <Navbar />
      <Center w="100%" minH="70vh" mt="2rem">
        <Box mx="1" maxW="md" p="2rem" borderWidth="3px" borderRadius="lg">
          <Heading mb="4" size="lg" textAlign="center">
            Sign in
          </Heading>
          <form onSubmit={handleSubmit(handleLogin)}>
            <FormControl isInvalid={errors.email}>
              <FormLabel>Email</FormLabel>
              <Input
                textTransform={"none"}
                type="email"
                placeholder="email"
                {...register("email", emailValidate)}
              />
              <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors.password}>
              <FormLabel>password</FormLabel>
              <Input
                type="password"
                placeholder="password"
                {...register("password", passwordValidate)}
              />
              <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
            </FormControl>
            <Button
              mt={4}
              type="submit"
              colorScheme={"teal"}
              width="100%"
              isLoading={isLoading}
            >
              Submit
            </Button>
          </form>
          <Text textAlign={"center"} my="0.3rem">
            or
          </Text>
          <Button my="3" width="100%" onClick={handleGoogle}>
            <Text as="span" mr={"1rem"}>
              Log in with Google
            </Text>
            <FcGoogle fontSize={"1.4rem"} mx="1rem" />
          </Button>
          <Text mt={4}>
            don't have an account?{" "}
            <Link to={"/register"} color="teal.500" as={RouterLink}>
              register
            </Link>{" "}
            instead
          </Text>
          <Text textAlign={"center"} py="1rem">
            Or
          </Text>
          <Text textAlign={"center"}>
            Login as{" "}
            <Link to="/adminlogin" color="teal.500" as={RouterLink}>
              Admin
            </Link>
          </Text>
        </Box>
      </Center>
    </Box>
  );
};

export default Login;
